export default __webpack_public_path__ + "static/media/sustainingthefaith.0f2dc4f3.png";